import React from 'react';
import PropTypes from 'prop-types';

import PdpIcon from '../product/pdpIcon';
import { Picture, Responsive, imageShape } from './shared';

export const HERO_IMAGE_SIZES = '(min-width: 992px) 393px, 63vw';

export const HeroFacts = ({ facts }) => (
  <ul className="lnd-facts">
    {facts.map((fact) => (
      <li key={fact.desktop}>
        <PdpIcon name={fact.icon} size={16} />
        <Responsive desktop={fact.desktop} phone={fact.phone} />
      </li>
    ))}
  </ul>
);

HeroFacts.propTypes = {
  facts: PropTypes.arrayOf(
    PropTypes.shape({
      icon: PropTypes.string.isRequired,
      desktop: PropTypes.string.isRequired,
      phone: PropTypes.string,
    }),
  ).isRequired,
};

// Three overlapping photos and a handwritten tag. The tag font (Caveat-GiftTag) is a subset,
// so new tag notes need their glyphs in public/static/fonts/Caveat-GiftTag.woff2.
export const HeroCollage = ({ images, tag }) => (
  <div className="lnd-collage" aria-hidden="true">
    <div className="lnd-print lnd-print--block">
      <Picture image={images.block} sizes={HERO_IMAGE_SIZES} alt="" priority />
    </div>
    <div className="lnd-print lnd-print--couple">
      <Picture image={images.couple} sizes="(min-width: 992px) 254px, 41vw" alt="" />
    </div>
    <div className="lnd-print lnd-print--tiny">
      <Picture image={images.tiny} sizes="242px" alt="" />
    </div>
    <div className="lnd-tag">
      <p className="lnd-tag-to">{tag.to}</p>
      <p className="lnd-tag-note">
        {tag.note.map((line, index) => (
          <React.Fragment key={line}>
            {index > 0 && <br />}
            {line}
          </React.Fragment>
        ))}
      </p>
    </div>
  </div>
);

HeroCollage.propTypes = {
  images: PropTypes.shape({
    block: imageShape.isRequired,
    couple: imageShape.isRequired,
    tiny: imageShape.isRequired,
  }).isRequired,
  tag: PropTypes.shape({
    to: PropTypes.string.isRequired,
    note: PropTypes.arrayOf(PropTypes.string).isRequired,
  }).isRequired,
};
